var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 20
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.5 1.75V14.36a.507.507 0 0 1-.5.513c-.276 0-.5-.23-.5-.513V1.751L5.354 4.978c-.196.2-.512.2-.708 0a.522.522 0 0 1 0-.725l4-4.103c.196-.2.512-.2.708 0l4 4.103c.195.2.195.525 0 .725-.196.2-.512.2-.708 0L9.5 1.751ZM0 11.283c0-.283.224-.513.5-.513s.5.23.5.513v5.641c0 1.133.895 2.051 2 2.051h12c1.105 0 2-.918 2-2.05v-5.642c0-.283.224-.513.5-.513s.5.23.5.513v5.641c0 1.7-1.343 3.077-3 3.077H3c-1.657 0-3-1.378-3-3.077v-5.64Z",
  fill: "currentColor",
  fillRule: "nonzero"
})));
export default SvgIconShare;